'use strict';

var React = require('react');
var Border = require('../common/Border');
var appTypes = require('../../types/appTypes');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');

/*
 * 按钮栏组件
 */

var ButtonBarItem = React.createClass({
  propTypes: {
    onClickEvent: React.PropTypes.func.isRequired,
    width: React.PropTypes.number,
    left: React.PropTypes.number,
    text: React.PropTypes.string,
    backgroundColor: React.PropTypes.string,
    borderColor: React.PropTypes.string
  },

  render: function () {
    var backgroundStyle;

    backgroundStyle = {
      position: 'absolute',
      left: this.props.left,
      width: this.props.width,
      height: this.props.height,
      borderColor: this.props.borderColor,
      borderWidth: this.props.borderWidth,
      borderStyle: 'none',
      borderLeftStyle: this.props.borderVisible ? 'solid' : 'none',
      backgroundColor: this.props.backgroundColor,
      color: this.props.color,
      textAlign: 'center',
      textDecoration: 'inherit',
      lineHeight: this.props.height + 'px',
      whiteSpace:'nowrap',
      overflow:'hidden'
    };
    backgroundStyle.borderRightStyle = backgroundStyle.borderLeftStyle;

    return (
      <div
        style={backgroundStyle}
        onClick={this._onSelfClick}
        onMouseOver={this._onMouseOver.bind(this,this.props.index)}
        onMouseOut={this._onMouseOut.bind(this,this.props.index)}>
        <label>{this.props.text}</label>
      </div>)
  },

  _onSelfClick: function (e) {
    if (this.props.onClickEvent) {
      this.props.onClickEvent(e, this.props.index);
    }
  },
  _onMouseOver: function (index) {
    if (this.props.onMouseOver) {
      this.props.onMouseOver(index);
    }
  },
  _onMouseOut: function (index) {
    if (this.props.onMouseOut) {
      this.props.onMouseOut(index)
    }
  }
});

var ButtonBar = React.createClass({

  getInitialState: function () {
    return {
      selectedIndex: this.props.selectedIndex
    };
  },

  render: function () {
    var selfWidth = styleHelper.getWidth(this.props);
    var borderVisible = styleHelper.getPropertyValue(this.props, 'borderVisible');
    var borderWidth = styleHelper.getBorderWidth(this.props);
    var textArray = util.Text.delimitText(styleHelper.getText(this.props), util.Text.DM_COMMA);
    var itemWidth = textArray.length !== 0 ? (selfWidth / textArray.length) : 0;
    var style;
    var left = 0;
    var w;
    if (textArray.length) {
      if (borderVisible) {
        itemWidth = (selfWidth + borderWidth * (textArray.length - 1)) / textArray.length;
        w = itemWidth - borderWidth * 2;
      } else {
        itemWidth = selfWidth / textArray.length;
        w = itemWidth;
      }
    } else {
      itemWidth = 0;
    }

    style = styleHelper.StyleUtil(this.props).size().background().border().text().style;
    style.boxSizing = 'border-box';

    styleHelper.shrinkageWordSpacing(style);
    return (<div style={style}>
      {
        textArray.map(function (text, index) {
          text = text.trim();
          if (index) {
            if (borderVisible) {
              left += (itemWidth - styleHelper.getBorderWidth(this.props));
            } else {
              left += itemWidth;
            }
          }
          return (<ButtonBarItem
            key={index}
            text={text}
            width={w}
            height={styleHelper.getHeight(this.props) - (borderVisible?(this.props.thickness * 2):0)}
            left={left}
            index={index}
            color={index===this.state.selectedIndex?styleHelper.getSelectedTextColor(this.props):styleHelper.getTextColor(this.props)}
            borderVisible={styleHelper.getPropertyValue(this.props,'borderVisible')}
            borderColor={styleHelper.getPropertyValue(this.props,'borderColor')}
            borderWidth={styleHelper.getBorderWidth(this.props)}
            backgroundColor={index === this.state.selectedIndex ? this.props.selectedColor : ((this.props.showHover && index === this.state.hoverIndex) ? this.props.hoveredColor : styleHelper.getBackgroundColor(this.props))}
            onClickEvent={this.onItemClick}
            onMouseOver={this.onItemMouseOver}
            onMouseOut={this.onItemMouseOut}
          />);
        }, this)
      }
    </div>);
  },

  onItemClick: function (e, index) {
    this.setState({selectedIndex: index});
  },

  onItemMouseOver: function (index) {
    if (this.props.showHover) {
      this.setState({hoverIndex: index});
    }

  },

  onItemMouseOut: function () {
    this.setState({hoverIndex: -1});
  },

  componentDidMount: function () {
    $(ReactDOM.findDOMNode(this))
      .bind('itemClick', this.onItemClick);
  }

});

module.exports = ButtonBar;



// WEBPACK FOOTER //
// ./src/views/Components/ButtonBar.jsx